import {
  CREATE_PRODUCTCATEGORY_FAILURE,
  CREATE_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_SUCCESS,
  GET_ALL_PRODUCTCATEGORY_FAILURE,
  DELETE_PRODUCTCATEGORY_REQUEST,
  DELETE_PRODUCTCATEGORY_FAILURE,
  UPDATE_PRODUCTCATEGORY_REQUEST,
  UPDATE_PRODUCTCATEGORY_FAILURE,
} from "./ActionType";

const initialState = {
  productCategories: [],
  loading: false,
  error: "",
};

export const adminProductCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRODUCTCATEGORY_REQUEST:
      return { ...state, loading: true };

    case CREATE_PRODUCTCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_PRODUCTCATEGORY_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PRODUCTCATEGORY_SUCCESS:
      return { ...state, loading: false, error: "", productCategories: action.payload };

    case GET_ALL_PRODUCTCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PRODUCTCATEGORY_REQUEST:
      return { ...state, loading: true };

    case DELETE_PRODUCTCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PRODUCTCATEGORY_REQUEST:
      return { ...state, loading: true };

    case UPDATE_PRODUCTCATEGORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
